export const formatDateAsItIs = (utcDateString) => {
    const date = new Date(utcDateString);

    // Get UTC day, month, year, hours, and minutes
    const day = date.getUTCDate().toString().padStart(2, '0');  // Day with leading zero
    const month = date.toLocaleString('default', { month: 'short', timeZone: 'UTC' });  // Short month name (e.g., 'Mar')
    const year = date.getUTCFullYear();  // Full year (e.g., 2025)

    // Return formatted string
    return `${day} ${month}, ${year} `;
};


export const formatDate = (utcDateString) => {
    const date = new Date(utcDateString);

    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();

    // Get hours and minutes
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');

    // Determine AM or PM
    const ampm = hours >= 12 ? 'PM' : 'AM';

    // Convert to 12-hour format
    hours = hours % 12 || 12; // Converts 0 to 12

    const formattedHours = hours.toString().padStart(2, '0');

    return `${day} ${month}, ${year} ${formattedHours}:${minutes} ${ampm}`;
};

export function formatDateToLocalInput(date) {
    const d = new Date(date);
    const pad = (n) => String(n).padStart(2, '0');

    const year = d.getFullYear();
    const month = pad(d.getMonth() + 1);
    const day = pad(d.getDate());
    const hours = pad(d.getHours());
    const minutes = pad(d.getMinutes());

    return `${year}-${month}-${day}T${hours}:${minutes}`;
}
